
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[slug]/olvidaste-contrasena",
      function () {
        return require("private-next-pages/org/[slug]/olvidaste-contrasena.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[slug]/olvidaste-contrasena"])
      });
    }
  